import { render, staticRenderFns } from "./banner-right.vue?vue&type=template&id=3a4a361e&"
import script from "./banner-right.vue?vue&type=script&lang=js&"
export * from "./banner-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports